module.exports = __webpack_public_path__ + "static/img/1.2b840b6e.jpg";